import { getPrintersEndpoint } from './endpoints';

const getPrinters = async tokenMemo => {
  try {
    const token = await tokenMemo;

    const response = await fetch(getPrintersEndpoint(), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await response.json();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};
export default getPrinters;
